import { API_ROUTE_PREFIX, API_ROUTE_V2_PREFIX } from "@tm/api-utils";
import { isOnServer, LOB, PARTNER, PartnerType } from "@tm/isomorphic-utils";

export const getHTTPRoutePrefix = (partner: PartnerType) => {
  if (isOnServer()) {
    if (partner === PARTNER.MYBIZ || partner === PARTNER.MYPARTNER) {
      return API_ROUTE_V2_PREFIX;
    }
  }
  return API_ROUTE_PREFIX;
};

export const getLobOnServerSide = (partner: PartnerType) => {
  if (isOnServer()) {
    if (partner === PARTNER.MYPARTNER) {
      return LOB.MYPARTNER;
    } else if (partner === PARTNER.MYBIZ) {
      return LOB.STANDALONE_MYBIZ;
    }
    return LOB.STANDALONE;
  }
  return LOB.STANDALONE;
};

export const getPathPartnerOnServerSide = (partner: PartnerType) => {
  if (partner === PARTNER.MYPARTNER || partner === PARTNER.MYBIZ) {
    return PARTNER.MMT;
  }
  return partner;
};
